import { ALGOLIA_CONTAINER_ID } from 'views/consts'

import store from 'shared/store'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import { runSafeEachScript } from 'views/assets/scripts/runScripts'
import modal from 'views/assets/scripts/modal'
import expander from 'views/assets/scripts/expander'
import refinementList from 'views/assets/scripts/refinementList'
import productFilter from 'views/assets/scripts/productFilter'
import nowModal from 'views/assets/scripts/nowModal'
import chargeUrlSearchParams from 'views/assets/scripts/chargeUrlSearchParams'
import hitsPerPage from 'views/assets/scripts/hitsPerPage'

const CLIENT_SCRIPTS = [
  modal,
  expander,
  refinementList,
  productFilter,
  nowModal,
  chargeUrlSearchParams,
  hitsPerPage
]

const initAlgoliaSearchComponents = async container => {
  const {
    publicConfig: { locale }
  } = store.getPublicRuntimeConfig()

  const catalogs = await loadCatalogs(locale)

  const hydrateAlgoliaSearchComponents = await import(
    /* webpackChunkName: "AlgoliaSearchContainerWithHydration", webpackPrefetch: true */
    './hydrateAlgoliaSearchComponents'
  )
  hydrateAlgoliaSearchComponents.default({
    container,
    locale,
    catalogs
  })

  runSafeEachScript(CLIENT_SCRIPTS)
}

export default async () => {
  const container = document.getElementById(ALGOLIA_CONTAINER_ID)
  if (container) {
    await initAlgoliaSearchComponents(container)
  }
}
